import React from "react";
import styles from "./new.module.css";
import { ButtonProps } from "../../types/form";

type ModernButtonProps = ButtonProps & {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children?: React.ReactNode;
};

const getClassNames = (...classNames: Array<string | undefined>) => {
  return classNames
    .filter(Boolean)
    .flatMap((className) => className!.split(" "))
    .filter(Boolean)
    .map((className) => styles[className] || className)
    .join(" ");
};

const Button = ({
  onClick,
  type = "submit",
  title,
  size = "medium",
  bgColor,
  className,
  disabled,
  loading,
  style,
  leftIcon,
  rightIcon,
  children,
}: ModernButtonProps) => {
  const isDisabled = disabled || loading;

  return (
    <div className={`${styles.InputContainer} ${styles[size || ""]}`}>
      <button
        type={type}
        onClick={onClick}
        className={getClassNames("buttonBase", bgColor, className)}
        disabled={isDisabled}
        style={style}
        aria-busy={loading}
      >
        {loading ? (
          <span className={styles.loading} aria-hidden="true" />
        ) : leftIcon ? (
          <span className={styles.buttonIcon}>{leftIcon}</span>
        ) : null}

        <span className={styles.buttonText}>{children || title}</span>

        {!loading && rightIcon ? (
          <span className={styles.buttonIcon}>{rightIcon}</span>
        ) : null}
      </button>
    </div>
  );
};

export default Button;
